import { createFileRoute, Outlet } from '@tanstack/react-router'
import KioskNotificationComponent from '../../../components/KiosksNotificationComponent'

export const Route = createFileRoute('/_authenticated/cameras')({
  component: CamerasLayout,
})

function CamerasLayout() {
  return (
    <>
      <KioskNotificationComponent />
      <Outlet />
    </>
  )
}
